import React from 'react';

const StatsCard = ({ stats }) => {
  if (!stats) return null;

  const calculateTotals = () => {
    let totalHandlers = stats.totalHandlers || 0;
    let totalBreeders = stats.totalBreeders || 0;
    let totalBirds = 0;

    if (stats.bySection) {
      Object.values(stats.bySection).forEach(section => {
        totalBirds += section.totalBirds || 0;
      });
    }

    return { totalHandlers, totalBreeders, totalBirds };
  };

  const totals = calculateTotals();

  return (
    <div className="mb-5">
      {/* Main Stats Card */}
      <div className="card shadow-sm border-0 mb-4" style={{ background: 'linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)' }}>
        <div className="card-body p-4">
          <h4 className="mb-4 d-flex align-items-center" style={{ color: '#0b3d91' }}>
            {/* <span className="me-2">📊</span> Race Overview */}
          </h4>
          
          <div className="row g-4">
            <div className="col-md-4">
              <div className="d-flex align-items-center">
                <div className="rounded-circle d-flex align-items-center justify-content-center me-3" 
                     style={{ width: '60px', height: '60px', background: 'linear-gradient(135deg, #0b3d91 0%, #1e5bb8 100%)', color: 'white' }}>
                  <h3 className="mb-0">{totals.totalHandlers}</h3>
                </div>
                <div>
                  <div className="fw-bold text-dark">Handlers</div>
                  <small className="text-muted">Active participants</small>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="d-flex align-items-center">
                <div className="rounded-circle d-flex align-items-center justify-content-center me-3" 
                     style={{ width: '60px', height: '60px', background: 'linear-gradient(135deg, #28a745 0%, #34ce57 100%)', color: 'white' }}>
                  <h3 className="mb-0">{totals.totalBreeders}</h3>
                </div>
                <div>
                  <div className="fw-bold text-dark">Breeders</div>
                  <small className="text-muted">Contributing birds</small>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="d-flex align-items-center">
                <div className="rounded-circle d-flex align-items-center justify-content-center me-3" 
                     style={{ width: '60px', height: '60px', background: 'linear-gradient(135deg, #17a2b8 0%, #1fc8db 100%)', color: 'white' }}>
                  <h3 className="mb-0">{totals.totalBirds}</h3>
                </div>
                <div>
                  <div className="fw-bold text-dark">Projected Birds</div>
                  <small className="text-muted">Handler capacity</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Section Breakdown */}
      {stats.bySection && (
        <>
          <hr className="my-4" style={{ borderColor: '#dee2e6' }} />
          
          <h6 className="mb-3 text-muted text-uppercase" style={{ fontSize: '0.875rem', letterSpacing: '0.5px' }}>
            By Section
          </h6>
          
          <div className="row g-3">
            {Object.entries(stats.bySection).map(([section, data]) => {
              return (
                <div key={section} className="col-md-4">
                  <div className="d-flex align-items-center p-2 rounded border" style={{ background: '#fff', borderColor: '#dee2e6' }}>
                    <div className="text-center flex-shrink-0" style={{ minWidth: '80px' }}>
                      <div className="fw-bold text-uppercase small" style={{ color: '#0b3d91', whiteSpace: 'nowrap' }}>
                        {section}
                      </div>
                    </div>
                    <div className="border-start mx-2" style={{ height: '30px' }}></div>
                    <div className="d-flex align-items-center flex-grow-1">
                      <div className="text-center flex-fill">
                        <div className="fw-bold">{data.handlers || 0}</div>
                        <small className="text-muted" style={{ fontSize: '0.7rem', whiteSpace: 'nowrap' }}>Handlers</small>
                      </div>
                      <div className="text-center flex-fill">
                        <div className="fw-bold">{data.totalBirds || 0}</div>
                        <small className="text-muted" style={{ fontSize: '0.7rem', whiteSpace: 'nowrap' }}>Birds</small>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
};

export default StatsCard;
